<template>	
	<section class="body">
		<div class="inner-wrapper">
			<EventListener @onLogin="setLogin">
				<div>
					<SideBar :rr="this.$route" :logout="logout" :login="login"  />									
					<UserBar @onLogout="setLogout" :login="login" />				
					<section class="content-body" :style="'background-image: url(' + require('@/assets/img/vector-237.svg') + ')'">
						<div class="row">							
							<slot />							
						</div>						
					</section>					
				</div>
			</EventListener>
		</div>		
	</section>	
</template>

<script>

// Компонент обертки (шаблона), который используется для внутренних страниц приложения

import SideBar from '@/components/SideBar.vue'
import UserBar from '@/components/UserBar.vue'
import EventListener from '@/components/EventListener.vue'

export default {

	name: "InsideLayout",

	data() {
		return {			
			logout: false,
			login: false
		}			
	},

	components: {
		SideBar,
		UserBar,
		EventListener		
	},

	methods: {

		getRandomInt(min, max) {
			const minCeiled = Math.ceil(min);
			const maxFloored = Math.floor(max);
			return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
		},

		setLogin(){
			this.login = this.getRandomInt(1, 9999)
		},

		setLogout(){
			this.logout = this.getRandomInt(1, 9999)
		}
	},

	mounted() {
		let jivoScript = document.createElement('script')
		jivoScript.setAttribute('src', 'https://code.jivo.ru/widget/8FZhkdppJ6')
		jivoScript.setAttribute('async', 'true')
		document.head.appendChild(jivoScript)		
	}
}
</script>

<style scoped>

</style>